import React, { FC, Fragment, useRef } from 'react'
import { TextInput } from '@components/FormInputs/TextInput'
import { AddressAutocomplete } from '@components/AddressAutocomplete'
import { Props } from './Question'

export const TextInputFactory: FC<Props> = (props) => {
  const { value, onAnswerQuestion, error, id, onBlur, onKeyDown } = props
  const {
    autocomplete,
    autofill,
    formatter,
    key,
    placeholder,
    type,
    inputProps,
  } = props.inputData
  const inputRef = useRef<HTMLInputElement>(null)

  return (
    <Fragment>
      <TextInput
        id={id}
        name={key}
        type={type}
        value={value}
        onChange={onAnswerQuestion}
        onBlur={onBlur}
        placeholder={placeholder}
        formatter={formatter}
        autocomplete={autocomplete}
        error={error}
        inputRef={inputRef}
        onKeyDown={onKeyDown}
        {...inputProps}
      />

      {autofill === 'address' && (
        <AddressAutocomplete
          inputRef={inputRef}
          onAnswerQuestion={onAnswerQuestion}
          onKeyDown={onKeyDown}
        />
      )}
    </Fragment>
  )
}
